export const appVersion = "v0.2"
export const appVersionComplete = "Beta 0.5"

export const rootUrl = 'https://sd-gantt.vercel.app'
